import React from 'react';

const MembershipAgreementPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            Üyelik Sözleşmesi
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-xl font-semibold mb-4">MADDE 1 - TARAFLAR VE KONU</h2>
            
            <h3 className="text-lg font-semibold mb-3">1.1. SİTE SAHİBİ</h3>
            <div className="bg-gray-100 p-4 rounded-lg mb-4">
              <p><strong>Unvan:</strong> Fiel Home</p>
              <p><strong>Adres:</strong> MAHMUDİYE MAH. ERTUĞRUL GAZİ CAD. NO: 46 A İNEGÖL/BURSA</p>
              <p><strong>Telefon:</strong> +90 552 229 90 07</p>
              <p><strong>E-posta:</strong> info@fielhome.com</p>
              <p><strong>Web Sitesi:</strong> www.fielhome.com</p>
            </div>
            
            <h3 className="text-lg font-semibold mb-3">1.2. ÜYE</h3>
            <p className="mb-4">
              www.fielhome.com internet sitesine üye olan gerçek veya tüzel kişi
            </p>
            
            <h3 className="text-lg font-semibold mb-3">1.3. KONU</h3>
            <p className="mb-4">
              Bu sözleşme, ÜYE'nin www.fielhome.com internet sitesine üyeliği 
              ile ilgili hak ve yükümlülükleri düzenler.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 2 - ÜYELİK KOŞULLARI</h2>
            <h3 className="text-lg font-semibold mb-3">2.1. Genel Koşullar</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Üyelik 18 yaş ve üzeri kişiler içindir</li>
              <li>18 yaş altı üyelik için veli/vasi onayı gereklidir</li>
              <li>Bir kişi sadece bir üyelik hesabı açabilir</li>
              <li>Tüm bilgiler doğru ve güncel olmalıdır</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">2.2. Kayıt İşlemi</h3>
            <p className="mb-4">
              Üyelik için aşağıdaki bilgiler gereklidir:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Ad ve soyad</li>
              <li>E-posta adresi</li>
              <li>Telefon numarası</li>
              <li>Doğum tarihi</li>
              <li>Güvenli şifre</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 3 - ÜYE HAKLARI</h2>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Tüm ürünleri görüntüleyebilme</li>
              <li>Alışveriş yapabilme</li>
              <li>Sipariş geçmişini görüntüleyebilme</li>
              <li>Favori ürünler listesi oluşturabilme</li>
              <li>Özel indirim ve kampanyalardan yararlanabilme</li>
              <li>Müşteri hizmetlerinden destek alabilme</li>
              <li>Kişisel verilerini görüntüleme ve düzeltme</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 4 - ÜYE YÜKÜMLÜLÜKLERİ</h2>
            <h3 className="text-lg font-semibold mb-3">4.1. Genel Yükümlülükler</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Doğru ve güncel bilgi vermek</li>
              <li>Şifresini güvenli tutmak</li>
              <li>Hesabını başkalarıyla paylaşmamak</li>
              <li>Site kurallarına uymak</li>
              <li>Yasalara uygun davranmak</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">4.2. Yasak Faaliyetler</h3>
            <p className="mb-4">
              Üyeler aşağıdaki faaliyetleri yapamazlar:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Sahte bilgi vermek</li>
              <li>Başkalarının hesabını kullanmak</li>
              <li>Site güvenliğini tehlikeye atmak</li>
              <li>Spam mesaj göndermek</li>
              <li>Telif hakkı ihlali yapmak</li>
              <li>Müstehcen içerik paylaşmak</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 5 - KİŞİSEL VERİLER</h2>
            <h3 className="text-lg font-semibold mb-3">5.1. Veri Toplama</h3>
            <p className="mb-4">
              Topladığımız kişisel veriler:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Kimlik bilgileri (ad, soyad, T.C. kimlik no)</li>
              <li>İletişim bilgileri (telefon, e-posta, adres)</li>
              <li>Alışveriş bilgileri (sipariş geçmişi, tercihler)</li>
              <li>Teknik bilgiler (IP adresi, çerez verileri)</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">5.2. Veri Kullanımı</h3>
            <p className="mb-4">
              Kişisel verileriniz aşağıdaki amaçlarla kullanılır:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Üyelik hizmetlerinin sunulması</li>
              <li>Sipariş ve teslimat işlemleri</li>
              <li>Müşteri hizmetleri</li>
              <li>Pazarlama faaliyetleri (onay halinde)</li>
              <li>Yasal yükümlülüklerin yerine getirilmesi</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 6 - ÜYELİK İPTALİ</h2>
            <h3 className="text-lg font-semibold mb-3">6.1. Üye Tarafından İptal</h3>
            <p className="mb-4">
              Üye istediği zaman üyeliğini iptal edebilir:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Hesap ayarlarından iptal edebilir</li>
              <li>Müşteri hizmetlerine başvurabilir</li>
              <li>E-posta ile bildirimde bulunabilir</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">6.2. Site Tarafından İptal</h3>
            <p className="mb-4">
              Aşağıdaki durumlarda üyelik iptal edilebilir:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Sözleşme ihlali</li>
              <li>Sahte bilgi kullanımı</li>
              <li>Yasadışı faaliyetler</li>
              <li>Site güvenliğini tehlikeye atma</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 7 - SORUMLULUK SINIRI</h2>
            <p className="mb-4">
              Site, aşağıdaki durumlardan sorumlu değildir:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Üçüncü kişilerden kaynaklanan zararlar</li>
              <li>Sistem arızalarından kaynaklanan kayıplar</li>
              <li>Üyenin yanlış bilgi vermesinden doğan sorunlar</li>
              <li>İnternet bağlantısı problemleri</li>
              <li>Mücbir sebeplerden kaynaklanan aksamalar</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 8 - DEĞİŞİKLİKLER</h2>
            <p className="mb-4">
              Site, bu sözleşmeyi önceden haber vererek değiştirebilir. 
              Değişiklikler site üzerinden duyurulur ve onayınız alınır.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 9 - UYUŞMAZLIK ÇÖZÜMÜ</h2>
            <p className="mb-4">
              Bu sözleşmeden doğan uyuşmazlıklarda İnegöl Mahkemeleri ve 
              İcra Müdürlükleri yetkilidir.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">MADDE 10 - YÜRÜRLÜK</h2>
            <p className="mb-4">
              Bu sözleşme, ÜYE tarafından elektronik ortamda kabul edildiği 
              anda yürürlüğe girer.
            </p>
            
            <div className="mt-8 p-4 bg-blue-50 rounded-lg">
              <p className="text-sm text-blue-800">
                <strong>ÖNEMLİ:</strong> Üye olmakla, bu sözleşmenin tüm maddelerini 
                okuduğunuzu ve kabul ettiğinizi beyan etmiş olursunuz.
              </p>
            </div>
            
            <p className="mt-8 text-sm text-gray-600">
              Bu sözleşme {new Date().toLocaleDateString('tr-TR')} tarihinde güncellenmiştir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipAgreementPage;
